import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Avatar } from "@material-ui/core";
import level2 from "../../../assets/level2.png";
import level3 from "../../../assets/level3.png";
import level4 from "../../../assets/level4.png";
import './Members.scss'

const columns = [
    { id: 'Membro', label: 'Membro'},
    { id: 'Cargo', label: 'Cargo'},
    { id: 'Empresa', label: 'Empresa'},
    { id: 'Interesses', label: 'Interesses'},
    { id: 'Acessos', label: 'Acessos'},
];

function createData( Membro, Cargo, Empresa, Interesses, Acessos) {
    return {  Membro, Cargo, Empresa, Interesses, Acessos };
}

function isOdd(n) {
    return Math.abs(n % 2) == 1;
}

const useStyles = makeStyles({
    root: {
        width: '100%',

        "& .MuiTableCell-head": {
            color: "#000000",
            backgroundColor: "white",
            fontSize: 16,
            fontWeight: 'bold',
        },
    
        "& .MuiTableCell-body": {
            color: "#000000",
            fontSize: 16,
        },
        "& .table-title": {
            color: "#303030",
            fontSize: 26,
        },
    },
    container: {
        maxHeight: 586,
        marginTop: 30
    },
    
});


function Members ({attenders}){

    const classes = useStyles();
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if ( attenders?.length > 0 ) {
            buildRows();
        }
        return () => {}

    }, [attenders]);
    
    function buildRows() {
        let rows = []
        attenders.map(attender => {
            rows.push(
                createData([ attender.photoURL, attender.name, attender.level], attender.role, [attender.company , ''], attender.tags, attender.accessUser )
            )
        })
        setRows(rows);
    }
    function getLevelImg(level) {
        switch (level) {
            case 2:
                return level2;
            case 3:
                return level3;
            case 4:
                return level4;
            default:
                return level2;
        }
    }
    return (
        <Paper className={classes.root} style={{boxShadow: "none"}} >
            <label className='table-title'> Informações dos membros </label>
            <TableContainer className={classes.container}>
                <Table stickyHeader>
                    <TableHead >
                        <TableRow>
                        {columns.map((column) => (
                            <TableCell
                            key={column.id}
                            align={column.align}
                            style={{ minWidth: column.minWidth, borderBottom:"none" }}
                            >
                            {column.label}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {/* {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => { */}
                        {rows.map((row, index) => {
                        return (
                            <TableRow 
                                hover 
                                role="checkbox" 
                                tabIndex={-1} 
                                key={row.code}
                                style={{ background: isOdd(index) ? '#FFFFFF' : '#F8F9FF'}}
                            >
                            {columns.map((column) => {
                                return (
                                <TableCell style={{borderBottom:"none"}} key={column.id} align={column.align}>
                                    {column.id === 'Membro' &&
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ marginLeft: 5, marginRight: 20 }}>
                                                { row[column.id][2] > 1 &&
                                                    <img style={{position: 'relative', margin: '-20px 31px'}} src={getLevelImg(row[column.id][2])} height={15} />
                                                }
                                                
                                                { row[column.id][2] <= 1 &&
                                                    <div style={{position: 'relative', margin: '-20px 38px'}}/>
                                                }
                                                <Avatar src={row[column.id][0]}  />
                                            </div>
                                            {  row[column.id][1] }
                                        </div>
                                    }

                                    {
                                        column.id === 'Empresa' &&                                
                                        <a style={{fontWeight:'bold', color: '#0256AD', textDecoration: 'none' }} href={row[column.id][1]}>{row[column.id][0]}</a>
                                    }

                                    {   
                                        ( 
                                            column.id !== 'Membro' &&
                                            column.id !== 'Empresa'                                    
                                        ) &&
                                        row[column.id]
                                    }
                                </TableCell>
                                );
                            })}
                            </TableRow>
                        );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}

export default Members;